(function () {
  var sections = document.querySelectorAll("[data-diagnox-faqs]");
  if (!sections.length) return;

  function animateAnswer(wrap, open) {
    if (!wrap) return;

    if (open) {
      wrap.style.maxHeight = "0px";
      requestAnimationFrame(function () {
        wrap.style.maxHeight = wrap.scrollHeight + "px";
        window.setTimeout(function () {
          if (wrap.closest(".diagnox-faqs__item.is-open")) {
            wrap.style.maxHeight = "none";
          }
        }, 320);
      });
      return;
    }

    wrap.style.maxHeight = wrap.scrollHeight + "px";
    requestAnimationFrame(function () {
      wrap.style.maxHeight = "0px";
    });
  }

  function setItemOpen(item, open) {
    var trigger = item.querySelector("[data-faq-trigger]");
    var answer = item.querySelector("[data-faq-answer]");
    item.classList.toggle("is-open", open);
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
    animateAnswer(answer, open);

    if (open && answer) {
      answer.querySelectorAll("video").forEach(function (video) {
        var refresh = function () {
          if (!item.classList.contains("is-open")) return;
          answer.style.maxHeight = "none";
        };
        video.addEventListener("loadedmetadata", refresh, { once: true });
        video.addEventListener("loadeddata", refresh, { once: true });
      });
    }
  }

  function syncOpenHeights(scope) {
    var openItems = scope.querySelectorAll(".diagnox-faqs__item.is-open [data-faq-answer]");
    openItems.forEach(function (wrap) {
      wrap.style.maxHeight = "none";
    });
  }

  function initAccordion(scope) {
    var items = Array.prototype.slice.call(scope.querySelectorAll("[data-faq-item]"));
    items.forEach(function (item) {
      var trigger = item.querySelector("[data-faq-trigger]");
      var answer = item.querySelector("[data-faq-answer]");
      if (!trigger || !answer) return;

      if (item.classList.contains("is-open")) {
        answer.style.maxHeight = "none";
      } else {
        answer.style.maxHeight = "0px";
      }

      trigger.addEventListener("click", function () {
        var willOpen = !item.classList.contains("is-open");
        items.forEach(function (other) {
          if (other !== item && other.classList.contains("is-open")) {
            setItemOpen(other, false);
          }
        });
        setItemOpen(item, willOpen);
      });
    });
  }

  function activateTab(section, tabId) {
    var tabs = section.querySelectorAll("[data-faq-tab]");
    var panels = section.querySelectorAll("[data-faq-panel]");

    tabs.forEach(function (tab) {
      var active = tab.getAttribute("data-faq-tab") === tabId;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
    });

    panels.forEach(function (panel) {
      var active = panel.getAttribute("data-faq-panel") === tabId;
      panel.classList.toggle("is-active", active);
      if (active) {
        panel.removeAttribute("hidden");
        syncOpenHeights(panel);
      } else {
        panel.setAttribute("hidden", "");
      }
    });
  }

  function activateProduct(section, productId) {
    var links = section.querySelectorAll("[data-product-nav]");
    var panels = section.querySelectorAll("[data-product-panel]");
    var matched = false;

    links.forEach(function (link) {
      var active = link.getAttribute("data-product-id") === String(productId);
      link.classList.toggle("is-active", active);
      link.setAttribute("aria-pressed", active ? "true" : "false");
    });

    panels.forEach(function (panel) {
      var isMatch = panel.getAttribute("data-product-panel") === String(productId);
      /* Same product can appear in multiple collections — only show the first panel. */
      var active = isMatch && !matched;
      if (isMatch) matched = true;
      panel.classList.toggle("is-active", active);
      if (active) {
        panel.removeAttribute("hidden");
        syncOpenHeights(panel);
      } else {
        panel.setAttribute("hidden", "");
      }
    });
  }

  function applyFaqMediaMap(section) {
    var mapEl =
      section.querySelector("[data-diagnox-faq-media-map]") ||
      document.querySelector("[data-diagnox-faq-media-map]");
    if (!mapEl) return;

    var map = {};
    try {
      map = JSON.parse(mapEl.textContent || "{}") || {};
    } catch (err) {
      return;
    }

    section.querySelectorAll("[data-faq-handle]").forEach(function (item) {
      var handle = item.getAttribute("data-faq-handle");
      var html = handle && map[handle];
      var slot = item.querySelector("[data-faq-media-slot]");
      if (!html || !slot) return;

      slot.innerHTML = html;
      slot.querySelectorAll("video").forEach(function (video) {
        video.setAttribute("controls", "");
        video.setAttribute("playsinline", "");
        if (!video.className) video.className = "diagnox-faqs__answer-video";
      });
      slot.querySelectorAll("img.metafield-file_reference, .diagnox-faq-media__inner > img").forEach(function (img) {
        if (img.closest("video")) return;
        img.classList.add("diagnox-faqs__answer-image");
      });
      slot.removeAttribute("hidden");
      var answer = item.querySelector(".diagnox-faqs__answer");
      if (answer) answer.classList.add("diagnox-faqs__answer--with-media");
    });
  }

  sections.forEach(function (section) {
    var defaultTab = section.getAttribute("data-default-tab");
    var defaultProduct = section.getAttribute("data-default-product");

    applyFaqMediaMap(section);

    section.querySelectorAll("[data-faq-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        if (section.classList.contains("is-searching")) return;
        activateTab(section, tab.getAttribute("data-faq-tab"));
      });
    });

    section.querySelectorAll("[data-product-nav]").forEach(function (link) {
      link.addEventListener("click", function () {
        if (section.classList.contains("is-searching")) return;
        activateProduct(section, link.getAttribute("data-product-id"));
      });
    });

    section.querySelectorAll("[data-faq-accordion]").forEach(function (accordion) {
      initAccordion(accordion);
    });

    if (defaultTab) activateTab(section, defaultTab);
    if (defaultProduct) activateProduct(section, defaultProduct);

    window.addEventListener(
      "resize",
      function () {
        var activePanel = section.querySelector(".diagnox-faqs__panel.is-active");
        if (activePanel) syncOpenHeights(activePanel);
      },
      { passive: true }
    );
  });

  function normalizeText(value) {
    return (value || "").toLowerCase().replace(/\s+/g, " ").trim();
  }

  function elementText(el) {
    return el ? normalizeText(el.textContent) : "";
  }

  function clearSearch(section) {
    section.classList.remove("is-searching");
    section.querySelectorAll("[data-faq-item]").forEach(function (item) {
      item.classList.remove("is-search-hidden");
    });

    var emptyEl = section.querySelector("[data-faq-search-empty]");
    if (emptyEl) emptyEl.setAttribute("hidden", "");

    var defaultTab = section.getAttribute("data-default-tab");
    var defaultProduct = section.getAttribute("data-default-product");
    if (defaultTab) activateTab(section, defaultTab);
    if (defaultProduct) activateProduct(section, defaultProduct);
  }

  function applySearch(section, query) {
    var q = normalizeText(query);
    if (!q) {
      clearSearch(section);
      return;
    }

    section.classList.add("is-searching");
    var matchCount = 0;
    var emptyEl = section.querySelector("[data-faq-search-empty]");

    section.querySelectorAll("[data-faq-panel]").forEach(function (panel) {
      if (panel.getAttribute("data-faq-panel") === "products") return;

      var panelHas = false;
      panel.querySelectorAll("[data-faq-item]").forEach(function (item) {
        var match = elementText(item).indexOf(q) !== -1;
        item.classList.toggle("is-search-hidden", !match);
        if (match) {
          panelHas = true;
          matchCount += 1;
        }
      });

      panel.classList.toggle("is-active", panelHas);
      if (panelHas) {
        panel.removeAttribute("hidden");
        syncOpenHeights(panel);
      } else {
        panel.setAttribute("hidden", "");
      }
    });

    var productsPanel = section.querySelector('[data-faq-panel="products"]');
    if (productsPanel) {
      var productsHas = false;

      productsPanel.querySelectorAll("[data-product-panel]").forEach(function (prodPanel) {
        var productText =
          elementText(prodPanel.querySelector(".diagnox-faqs__product-card-title")) +
          " " +
          elementText(prodPanel.querySelector(".diagnox-faqs__product-card-desc"));
        var productMatch = productText.indexOf(q) !== -1;
        var faqHas = false;

        prodPanel.querySelectorAll("[data-faq-item]").forEach(function (item) {
          var match = productMatch || elementText(item).indexOf(q) !== -1;
          item.classList.toggle("is-search-hidden", !match);
          if (match) {
            faqHas = true;
            matchCount += 1;
          }
        });

        var showPanel = faqHas || productMatch;
        prodPanel.classList.toggle("is-active", showPanel);
        if (showPanel) {
          productsHas = true;
          if (productMatch && !faqHas) matchCount += 1;
          prodPanel.removeAttribute("hidden");
          syncOpenHeights(prodPanel);
        } else {
          prodPanel.setAttribute("hidden", "");
        }
      });

      productsPanel.classList.toggle("is-active", productsHas);
      if (productsHas) {
        productsPanel.removeAttribute("hidden");
      } else {
        productsPanel.setAttribute("hidden", "");
      }
    }

    if (emptyEl) {
      if (matchCount > 0) {
        emptyEl.setAttribute("hidden", "");
      } else {
        emptyEl.removeAttribute("hidden");
      }
    }
  }

  document.addEventListener("diagnox:help-search", function (event) {
    var query = (event.detail && event.detail.query) || "";
    document.querySelectorAll("[data-diagnox-faqs]").forEach(function (section) {
      applySearch(section, query);
    });
  });

  var existingHelpInput = document.querySelector("[data-help-search-input]");
  if (existingHelpInput && existingHelpInput.value) {
    document.querySelectorAll("[data-diagnox-faqs]").forEach(function (section) {
      applySearch(section, existingHelpInput.value);
    });
  }
})();